import React, { useEffect, useState } from "react";
import { NODE_ENV } from "common/env";
import { ActionButton } from "../../Common/Buttons/ActionButton";
import { BannerContainer, BannerTextWrapper } from "./__styles__/StagingBanner";

export const StagingBanner = () => {
  const [showBanner, setShowBanner] = useState<boolean>(true);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--staging-banner-height",
      showBanner ? "32px" : "0px",
    );
  }, [showBanner]);

  return showBanner ?
      <BannerContainer environment={NODE_ENV}>
        <BannerTextWrapper>
          {NODE_ENV === "production" ?
            "On Feb 21st, 9 PM EST, Forerunner will be temporarily unavailable due to scheduled maintenance for approximately 4 hours to maintain top performance and reliability. Thank you for your understanding!"
          : `You're currently viewing the Forerunner ${NODE_ENV} environment`}
        </BannerTextWrapper>
        <ActionButton
          icon="x"
          variant="inverted"
          onClick={() => setShowBanner(false)}
          data-testid="close-icon"
          aria-label="Close Banner"
        />
      </BannerContainer>
    : null;
};
